import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

const CARDS = [
  { key: "posts", label: "Articoli blog", to: "/admin/blog" },
  { key: "products", label: "Prodotti", to: "/admin/prodotti" },
  { key: "quotes_new", label: "Preventivi nuovi", to: "/admin/preventivi", accent: true },
  { key: "quotes_total", label: "Preventivi totali", to: "/admin/preventivi" },
  { key: "trials_new", label: "Prove a casa nuove", to: "/admin/prove", accent: true },
  { key: "trials_total", label: "Prove a casa totali", to: "/admin/prove" },
  { key: "subscribers", label: "Iscritti newsletter", to: "/admin/iscritti" },
  { key: "chat_sessions", label: "Sessioni chat AI" },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
  }, []);

  return (
    <div className="p-8 md:p-12" data-testid="admin-dashboard">
      <div className="flex items-baseline justify-between mb-12">
        <div>
          <div className="font-mono text-[10px] tracking-[0.3em] text-[#007A8A] mb-2">
            — DASHBOARD
          </div>
          <h1 className="font-display text-5xl md:text-6xl tracking-tighter">Console Aéràs</h1>
        </div>
        <div className="font-mono text-[10px] tracking-widest uppercase text-[#52525b]">
          {new Date().toLocaleString("it-IT")}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#e4e4e7] border border-[#e4e4e7]">
        {CARDS.map((c) => {
          const value = stats?.[c.key] ?? "—";
          const CardWrap = c.to ? Link : "div";
          return (
            <CardWrap
              key={c.key}
              to={c.to}
              data-testid={`stat-${c.key}`}
              className={`bg-[#f4f4f5] p-8 min-h-[180px] flex flex-col justify-between group ${
                c.to ? "hover:bg-[#f4f4f5] transition-colors" : ""
              }`}
            >
              <div className="flex items-start justify-between">
                <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#3f3f46]">
                  {c.label}
                </div>
                {c.to && (
                  <ArrowUpRight
                    size={16}
                    className="text-[#52525b] group-hover:text-[#007A8A] transition-colors"
                  />
                )}
              </div>
              <div
                className={`font-display text-6xl md:text-7xl tracking-tighter ${
                  c.accent && value > 0 ? "text-[#FF4D00]" : "text-[#0a0a0a]"
                }`}
              >
                {value}
              </div>
            </CardWrap>
          );
        })}
      </div>

      <div className="mt-16">
        <div className="font-mono text-[10px] tracking-[0.3em] text-[#007A8A] mb-6">
          — AZIONI RAPIDE
        </div>
        <div className="flex flex-wrap gap-4">
          <Link to="/admin/blog" className="btn-ghost" data-testid="quick-new-post">Nuovo articolo</Link>
          <Link to="/admin/prodotti" className="btn-ghost" data-testid="quick-new-product">Nuovo prodotto</Link>
          <Link to="/admin/preventivi" className="btn-primary" data-testid="quick-view-quotes">Vedi preventivi →</Link>
        </div>
      </div>
    </div>
  );
}
